<script lang='jsx'>
  export default {
    render () {
      const year = new Date().getFullYear()
      return (
        <footer class='footer'>
          <div style={{ textAlign: 'right', padding: '2em 1em', color: '#666' }}>
            <p>&copy; {year} - Made with ❤️ &nbsp;by XuedongEdu.com</p>
          </div>
        </footer>
      )
    }
  }
</script>

<style lang='less'>
  .footer {
    background-color: whitesmoke;
    padding: 1em 0;
  }
</style>